var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { observe, action, observable, extendObservable, toJS } from "mobx";
import { EventsBySportIdRequest } from "sb-bff-integration";
import * as i from "../contracts";
import { FilterPredicate, SubFilterPredicate } from "../typings";
import { EmptyStatisticsData, StreamingFilterBlockConstant } from "../constants";
import { DateRangeMapper, compareArrays, mapStartDateTime, mapMarketsSelectionsOdds, prepareMarkets, mapLinkUrl, mapLeagueUrl, mapIsSelected, mapSelectionsOdds, mapEventComponent, updateLeagueRankID, FavoritesManager, MessageBus, mapStatisticsIcon } from "../helpers";
import { mapKickOffTime } from "../composables/mappers";
import { sortLeagues, sortEventsByTime } from "../composables/sorters";
import Debounce from "debounce-decorator";
import { BsUtilReceivers } from "sb-betslip-utils-contracts";
var Parser = /** @class */ (function () {
    function Parser(retriever, piper, requstParams, navFunctions, specialLeagues, parserCmsConfig) {
        this.piper = piper;
        this.retriever = retriever;
        this.topicPrefix = parserCmsConfig.topicPrefix + ".";
        this.clientId = parserCmsConfig.clientId;
        this.data = { events: observable([]), markets: observable([]), leagues: observable([]) };
        this.eventsDisposers = [];
        this.rootDisposers = [];
        this.sports = requstParams.sportIds;
        this.dateRange = requstParams.dateRange;
        this.allSportIds = requstParams.allSportIds;
        this.isFavoritesEnabled = retriever.dataProvider.isFavoritesEnabled;
        this.isMiniEventCard = retriever.dataProvider.isMiniEventCard;
        this.loader = retriever.loader;
        this.isInFavoritesState = false;
        this.dateFormat = retriever.dataProvider.shortDateFormat;
        this.timeFormat = retriever.dataProvider.shortTimeFormat;
        this.activeEventId = "";
        this.onLogin = this.onLogin.bind(this);
        this.favoritesManager = new FavoritesManager("favoriteEvents_" + parserCmsConfig.topicPrefix);
        this.oddStyle = 0;
        this.timeZone = 0;
        this.mapEventLinkUrl = mapLinkUrl.bind(this, navFunctions.adjustLivePath, navFunctions.adjustPath);
        this.mapLeagueLinkUrl = mapLeagueUrl.bind(this, navFunctions.adjustPath);
        this.mapStatisticsIcon = mapStatisticsIcon.bind(this, parserCmsConfig.showStatisticsIcon);
        this.specialLeagues = specialLeagues;
        this.hasSettlementDate = parserCmsConfig.hasSettlementDate;
        this.sortIPTopLeaguesFirst = parserCmsConfig.sortIPTopLeaguesFirst;
        this.messageBus = new MessageBus(this.topicPrefix, this);
        this.piper.appendAll(["mapGameScore", "mapGamePart", "mapEventIcons", "mapParticipants", "mapTeamNames", "mapStatistics", "mapKickOffState", "mapAggregatedEventsCount", "mapGameTime", "sortEventsByTime", "filterExpiredOutrights"]);
    }
    /**
     * Base functions
     */
    Parser.prototype.activate = function () {
        this.messageBus.attachListeners();
        this.attachAllObservables();
        this.retriever.activate();
        this.isFavoritesEnabled && this.favoritesManager.loadFavorites();
        this.messageBus.requestGlobalListeners(this.timeZoneChange.bind(this), this.oddStyleChange.bind(this), this.onLogin.bind(this));
    };
    Parser.prototype.deactivate = function () {
        this.sports = [];
        this.retriever.deactivate();
        this.dettachAllObservables();
        this.messageBus.dettachListeners();
        this.clearData();
    };
    Parser.prototype.setParams = function (sportIds) {
        this.sports = sportIds;
        this.retriever.setParams(sportIds);
    };
    /**
     *  Attach/dettach observers to data
     */
    // TODO: observe only what is shown on the screen
    Parser.prototype.attachEventObservables = function () {
        var _this = this;
        this.eventsDisposers = __spread(this.retriever.data.events.map(function (x) { return observe(x, _this.updateSingleEvent); }), this.retriever.data.markets.map(function (x) { return observe(x, _this.updateSingleMarkets); }), this.retriever.data.leagues.map(function (x) { return observe(x, _this.updateLeagues); }));
    };
    Parser.prototype.dettachEventObservables = function () {
        this.eventsDisposers.forEach(function (x) { return typeof x === "function" && x(); });
        this.eventsDisposers = [];
    };
    Parser.prototype.attachAllObservables = function () {
        var _this = this;
        this.attachEventObservables();
        this.rootDisposers = [
            observe(this.retriever.data.events, this.updateSingleEvent),
            observe(this.retriever.data.markets, this.updateSingleMarkets),
            observe(this.retriever.data.leagues, this.updateLeagues),
            observe(this.piper.pipeline, this.updateSingleEvent)
        ];
        Object.keys(this.retriever.subLoaders).forEach(function (type) {
            _this.rootDisposers.push(observe(_this.retriever.subLoaders[type], _this.updateLoader));
        });
    };
    Parser.prototype.dettachAllObservables = function () {
        this.rootDisposers.forEach(function (x) { return typeof x === "function" && x(); });
        this.rootDisposers = [];
        this.dettachEventObservables();
    };
    /**
     * Internal msg bus handlers
     */
    Parser.prototype.sportsChange = function (x) {
        if (!this.isInFavoritesState && compareArrays(x.sportIds, this.sports)) {
            return;
        }
        this.isInFavoritesState = false;
        this.sports = x.sportIds;
        this.setSubFilterPredicate(SubFilterPredicate.None);
        var shouldUpdateCurrentData = this.isCurrentSportsDataLoaded();
        this.retriever.querySportUpdate(x.sportIds);
        shouldUpdateCurrentData && this.updateData();
    };
    Parser.prototype.leaguesChange = function (x) {
        this.isInFavoritesState = false;
        this.sports = [x.sportId];
        this.retriever.queryLeaguesUpdate(x.leagueIds, this.sports);
    };
    Parser.prototype.regionsChange = function (x) {
        this.isInFavoritesState = false;
        this.sports = [x.sportId];
        this.retriever.queryRegionIdUpdate(x.regionId, x.sportId);
    };
    Parser.prototype.datesChange = function (x) {
        this.isInFavoritesState = false;
        this.dateRange = x.dateRange;
        var shouldUpdateCurrentData = this.isCurrentDatesDataLoaded();
        this.retriever.queryDatesUpdate(this.dateRange, this.sports);
        shouldUpdateCurrentData && this.updateData();
    };
    Parser.prototype.liveStreamChange = function () {
        if (this.isCurrentFilter(FilterPredicate.LiveStreaming)) {
            return;
        }
        this.isInFavoritesState = false;
        this.sports = this.allSportIds;
        this.dateRange = undefined;
        var shouldUpdateCurrentData = this.isCurrentTagsDataLoaded(EventsBySportIdRequest.EventTagsEnum.LiveStreaming);
        this.retriever.queryTagsUpdate(EventsBySportIdRequest.EventTagsEnum.LiveStreaming);
        shouldUpdateCurrentData && this.updateData();
    };
    Parser.prototype.favoritesChange = function () {
        if (this.isCurrentFilter(FilterPredicate.Favorites)) {
            return;
        }
        this.isInFavoritesState = true;
        this.sports = this.favoritesManager.favoriteSportIds;
        this.dateRange = undefined;
        this.retriever.queryFavoritesUpdate(this.favoritesManager.getFavorites);
    };
    Parser.prototype.liveStreamingChange = function () {
        this.setSubFilterPredicate(SubFilterPredicate.LiveStreaming);
    };
    Parser.prototype.fastMarketsChange = function () {
        this.setSubFilterPredicate(SubFilterPredicate.FastMarket);
    };
    Parser.prototype.allEventsChange = function () {
        this.setSubFilterPredicate(SubFilterPredicate.None);
    };
    Parser.prototype.activeEventIdChange = function (eventId) {
        if (!eventId) {
            return;
        }
        this.activeEventId = eventId;
        this.updateEvents();
    };
    Parser.prototype.onLogin = function (user) {
        user && this.retriever.setRegionId(user.CountryOfRegistration);
    };
    Parser.prototype.onLogout = function () {
        this.retriever.removeRegionId();
    };
    Parser.prototype.renewJWTToken = function () {
        this.retriever.renewJWTToken();
    };
    Parser.prototype.changedToSide = function (eventCardMessage) {
        var _this = this;
        this.isMiniEventCard = eventCardMessage.changedToSide;
        var cardConfig = this.getCardConfig(this.isMiniEventCard);
        if (!eventCardMessage.changedToSide) {
            this.retriever.subFilterPredicate = SubFilterPredicate.None;
            this.data.markets.replace(prepareMarkets(this.data.markets, cardConfig, this.specialLeagues, this.data.events));
        }
        this.data.events.forEach(function (ev) {
            mapEventComponent(ev, cardConfig, _this.isMiniEventCard);
        });
        this.retriever.dataProvider.isMiniEventCard = this.isMiniEventCard;
        if (eventCardMessage.initActiveEvent && !this.activeEventId && this.data.events.length) {
            var firstEvent = this.data.events[0];
            var isOutright = firstEvent.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString();
            this.activeEventId = firstEvent.id;
            this.messageBus.sendActiveEventMessage(this.activeEventId, isOutright);
        }
        this.sendTagsMessage(this.data.events);
    };
    Parser.prototype.betslipAddedItemsReceived = function (message) {
        var _this = this;
        this.dettachEventObservables();
        message.items.forEach(function (item) {
            var market = _this.data.markets.find(function (m) { return m.id === item.marketId; });
            var selection = market && market.selections.find(function (s) { return s.id === item.selectionId; });
            selection && (selection.isSelectionInBetslip = true);
        });
        this.attachEventObservables();
    };
    Parser.prototype.betslipRemovedItemsReceived = function (message) {
        var _this = this;
        this.dettachEventObservables();
        message.items.forEach(function (item) {
            var market = _this.data.markets.find(function (m) { return m.id === item.marketId; });
            var selection = market && market.selections.find(function (s) { return s.id === item.selectionId; });
            selection && (selection.isSelectionInBetslip = false);
        });
        this.attachEventObservables();
    };
    Parser.prototype.betslipClearedItemsReceived = function () {
        this.dettachEventObservables();
        this.data.markets.forEach(function (m) {
            m.selections.forEach(function (s) { return s.isSelectionInBetslip = false; });
        });
        this.attachEventObservables();
    };
    Parser.prototype.betSlipStatusReceived = function (message) {
        var selectionIdsInBetslip = message.items.map(function (item) { return item.selectionId; });
        this.dettachEventObservables();
        this.data.markets.forEach(function (m) {
            m.selections.forEach(function (s) { return s.isSelectionInBetslip = selectionIdsInBetslip.indexOf(s.id) > -1; });
        });
        this.attachEventObservables();
    };
    Parser.prototype.oddStyleChange = function (oddStyleMsg) {
        this.oddStyle = oddStyleMsg.currentSelectedOddStyle;
        this.dettachEventObservables();
        this.data.markets.replace(mapMarketsSelectionsOdds(this.data.markets, this.oddStyle));
        this.attachEventObservables();
    };
    Parser.prototype.timeZoneChange = function (timeZoneMsg) {
        this.timeZone = timeZoneMsg.currentSelectedTimeZone;
        this.dettachEventObservables();
        this.updateEventsTimeZone(this.data.events);
        this.attachEventObservables();
    };
    /**
     * Update data collections
     */
    Parser.prototype.updateEvents = function () {
        this.dettachEventObservables();
        var events = this.retriever.data.events.slice().map(function (ev) { return (__assign({}, ev)); });
        var filteredEvents = this.filterEvents(events);
        this.data.events.replace(this.mapEvents(this.piper.executePipeline(filteredEvents)));
        this.attachEventObservables();
    };
    Parser.prototype.updateMarkets = function () {
        this.dettachEventObservables();
        this.messageBus.sendBsUtilStatusMessage();
        var markets = this.retriever.data.markets.slice().map(function (m) {
            m.selections = m.selections.slice();
            m.tags = m.tags.slice();
            return __assign({}, m);
        });
        var cardConfig = this.getCardConfig(this.isMiniEventCard);
        var marketsFiltered = prepareMarkets(markets, cardConfig, this.specialLeagues, this.data.events);
        this.data.markets.replace(this.mapMarkets(marketsFiltered));
        this.attachEventObservables();
    };
    Parser.prototype.updateSingleMarkets = function (change) {
        this.dettachEventObservables();
        var removed = change.removed, added = change.added, cardConfig = this.getCardConfig(this.isMiniEventCard);
        this.handleRemove(removed, "markets");
        this.batchedUpdateSingleMarkets(change, cardConfig);
        this.addedMarkets(added, cardConfig);
    };
    Parser.prototype.mapEvents = function (events) {
        var _this = this;
        var cardConfig = this.getCardConfig(this.isMiniEventCard);
        return events.map(function (ev) {
            // add events missing properties
            mapKickOffTime(ev, _this.timeZone);
            mapStartDateTime(ev, {
                currentTimeZone: _this.timeZone,
                dateFormat: _this.dateFormat,
                timeFormat: _this.timeFormat,
                hasSettlementDate: _this.hasSettlementDate
            });
            mapIsSelected(ev, _this.activeEventId);
            _this.mapEventLinkUrl(ev);
            _this.isFavoritesEnabled && (ev.isInFavorites = _this.favoritesManager.isInFavorites(ev.id));
            mapEventComponent(ev, cardConfig, _this.isMiniEventCard);
            _this.mapStatisticsIcon(ev);
            return ev;
        });
    };
    Parser.prototype.mapMarkets = function (updatedMarkets) {
        var _this = this;
        return updatedMarkets.map(function (m) {
            var sel = mapSelectionsOdds(m.selections, _this.oddStyle);
            m.selections = sel;
            _this.addSelectionBetslipStatusProperty(m);
            return m;
        });
    };
    Parser.prototype.mapLeagues = function () {
        var _this = this;
        this.data.leagues.map(function (league) { return _this.mapLeagueLinkUrl(league); });
    };
    Parser.prototype.batchedUpdateSingleMarkets = function (change, cardConfig) {
        var _this = this;
        if (change.type === "update") {
            var markets = prepareMarkets([toJS(change.newValue)], cardConfig, this.specialLeagues, this.data.events);
            var filteredMarkets = this.mapMarkets(markets);
            filteredMarkets.forEach(function (market) {
                var index = _this.data.markets.findIndex(function (e) { return e.id === market.id; });
                if (index > -1) {
                    var oldMarket = _this.data.markets[index];
                    var selectedIds_1 = Array();
                    oldMarket.selections.forEach(function (s) { return s.isSelectionInBetslip && s.metadata.idSBTech && (selectedIds_1.push(s.metadata.idSBTech)); });
                    selectedIds_1.length && market.selections.forEach(function (s) { return s.isSelectionInBetslip = selectedIds_1.indexOf(s.metadata.idSBTech) > -1; });
                    _this.data.markets[index] = market;
                }
            });
        }
    };
    Parser.prototype.addedMarkets = function (added, cardConfig) {
        var _this = this;
        if (added) {
            var addedMarkets = prepareMarkets(added.slice().map(function (market) { return (__assign({}, market)); }), cardConfig, this.specialLeagues, this.data.events);
            addedMarkets = this.mapMarkets(addedMarkets);
            addedMarkets.forEach(function (market) { return _this.data.markets.push(market); });
            this.messageBus.sendBsUtilStatusMessage();
        }
    };
    Parser.prototype.updateLoader = function () {
        this.loader = this.retriever.loader;
        if (!this.retriever.loader.isLoading && this.retriever.loader.isFullLoadFinished) {
            var filteredEvents = this.filterEvents(this.retriever.data.events.slice());
            this.sendEventsCountMessage(filteredEvents.length);
            this.sendTagsMessage(filteredEvents);
        }
    };
    Parser.prototype.updateLeagues = function () {
        this.dettachEventObservables();
        var leagues = this.retriever.data.leagues.slice();
        var regions = this.retriever.activeRequests.fixtures ?
            this.retriever.activeRequests.fixtures.request.regionIds :
            (this.retriever.activeRequests.outrights ? this.retriever.activeRequests.outrights.request.regionIds : []);
        if (this.sortIPTopLeaguesFirst) {
            leagues = leagues.map(function (league) {
                var isFromRegion = regions && regions.indexOf(league.regionId) >= 0;
                updateLeagueRankID(league, isFromRegion);
                return league;
            });
        }
        var topLeagues = leagues.filter(function (league) { return league.isTopLeague ||
            regions && regions.indexOf(league.regionId) >= 0; });
        var notTopLeagues = leagues.filter(function (league) { return !(league.isTopLeague ||
            (regions && regions.indexOf(league.regionId) >= 0)); });
        this.data.leagues.replace(topLeagues.sort(sortLeagues).concat(notTopLeagues.sort(sortLeagues)));
        this.mapLeagues();
        this.attachEventObservables();
    };
    Parser.prototype.updateEventsTimeZone = function (events) {
        var _this = this;
        this.data.events.replace(events.map(function (event) { return mapStartDateTime(event, {
            currentTimeZone: _this.timeZone,
            dateFormat: _this.dateFormat,
            timeFormat: _this.timeFormat,
            hasSettlementDate: _this.hasSettlementDate
        }); }));
    };
    Parser.prototype.managedEvents = function (events) {
        var filteredEvents = this.filterEvents(events);
        var eventsToUpdate = this.mapEvents(this.piper.executePipeline(filteredEvents));
        return eventsToUpdate;
    };
    Parser.prototype.singleEventUpdate = function (change) {
        var _this = this;
        var hasUpdate = false;
        if (change.type === "update") {
            var events = this.managedEvents([toJS(change.newValue)]);
            events.forEach(function (ev) {
                var index = _this.data.events.findIndex(function (e) { return e.id === ev.id; });
                var hasEvent = index > -1;
                if (hasEvent) {
                    var startEventDate = _this.data.events[index].startEventDate;
                    hasUpdate = ev.startEventDate !== startEventDate;
                    _this.data.events[index] = ev;
                }
            });
        }
        return hasUpdate;
    };
    Parser.prototype.singleEventAddUpdate = function (added) {
        var _this = this;
        if (added) {
            var addedEvents = this.managedEvents(added.slice().map(function (ev) { return (__assign({}, ev)); }));
            addedEvents.forEach(function (ev) { return _this.data.events.push(ev); });
            return true;
        }
        return false;
    };
    Parser.prototype.updateSingleEvent = function (change) {
        var removed = change.removed, added = change.added;
        this.handleRemove(removed, "events");
        var shouldSortEvents = this.singleEventUpdate(change);
        shouldSortEvents = shouldSortEvents || this.singleEventAddUpdate(added);
        if (shouldSortEvents) {
            this.data.events.replace(this.data.events.sort(sortEventsByTime));
        }
    };
    Parser.prototype.addSelectionBetslipStatusProperty = function (market) {
        market.selections = market.selections.map(function (selection) {
            selection.isSelectionInBetslip === undefined && extendObservable(selection, {
                isSelectionInBetslip: false
            });
            return selection;
        });
    };
    Parser.prototype.handleRemove = function (collection, type) {
        var _this = this;
        if (collection) {
            collection.forEach(function (el) {
                _this.data[type].splice(_this.data[type].findIndex(function (x) { return x.id === el.id; }), 1);
            });
        }
    };
    /**
     * Filter data collections
     */
    Parser.prototype.getCardConfig = function (isMiniCard) {
        return isMiniCard
            ? this.retriever.dataProvider.cardConfigurationEventView
            : this.retriever.dataProvider.cardConfiguration;
    };
    Parser.prototype.filterEvents = function (events) {
        var to = this.dateRange && this.dateRange.from ? DateRangeMapper[this.dateRange.timeRange](this.dateRange.from) : "";
        var ids = this.retriever.filterPredicate === FilterPredicate.Favorites ? this.favoritesManager.favoriteEventIds : this.sports;
        var filterFn = this.retriever.getCurrentFilter.bind(this.retriever, ids, this.dateRange && this.dateRange.from, to);
        var filteredEvents = events.filter(filterFn);
        return filteredEvents;
    };
    Parser.prototype.isCurrentFilter = function (newFilter) {
        return this.retriever.filterPredicate === newFilter;
    };
    Parser.prototype.isCurrentSubFilter = function (newFilter) {
        return this.retriever.subFilterPredicate === newFilter;
    };
    Parser.prototype.setSubFilterPredicate = function (newFilter) {
        if (this.isCurrentSubFilter(newFilter)) {
            return;
        }
        this.isInFavoritesState = false;
        this.dateRange = undefined;
        this.retriever.subFilterPredicate = newFilter;
        this.updateEvents();
    };
    /**
     * Send messages via msg bus
     */
    Parser.prototype.sendEventsCountMessage = function (count) {
        var sport = this.retriever.filterPredicate === FilterPredicate.LiveStreaming || this.sports.length === 0 ?
            StreamingFilterBlockConstant : this.sports[0];
        this.messageBus.sendEventCountMessage(count, sport);
    };
    Parser.prototype.sendTagsMessage = function (events) {
        var hasLiveStreamEvents = false;
        var hasFastMarketsEvents = false;
        for (var i_1 = 0; i_1 < events.length; i_1 += 1) {
            var ev = events[i_1];
            ev.tags.indexOf(EventsBySportIdRequest.EventTagsEnum.LiveStreaming.toString()) > -1 && (hasLiveStreamEvents = true);
            ev.tags.indexOf(EventsBySportIdRequest.EventTagsEnum.FastMarket.toString()) > -1 && (hasFastMarketsEvents = true);
            if (hasLiveStreamEvents && hasFastMarketsEvents) {
                break;
            }
        }
        var result = { hasLiveStreamEvents: hasLiveStreamEvents, hasFastMarketsEvents: hasFastMarketsEvents };
        this.messageBus.sendTagsMessage(result);
        return result;
    };
    Parser.prototype.sendBsUtilItemsAddMessage = function (items) {
        this.messageBus.sendBsUtilItemsAddMessage({
            receiverIds: [BsUtilReceivers.FullBetSlip],
            items: items
        });
    };
    Parser.prototype.sendBsUtilItemsRemoveMessage = function (items) {
        this.messageBus.sendBsUtilItemsRemoveMessage({
            receiverIds: [BsUtilReceivers.FullBetSlip],
            items: items
        });
    };
    /**
     * Handlers triggered from State
     */
    Parser.prototype.manageFavorites = function (event) {
        event.isInFavorites = !event.isInFavorites;
        this.favoritesManager.manageFavorites(event);
    };
    Parser.prototype.getOpenGameData = function (event, ev) {
        if (!event) {
            return;
        }
        var eventTyprForGameBlock;
        if (event.isLive) {
            eventTyprForGameBlock = event.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString() ? 199 : 1;
        }
        else {
            eventTyprForGameBlock = event.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString() ? 99 : 0;
        }
        return {
            event: ev,
            id: parseInt(event.id),
            isLive: event.isLive,
            evTypeForGameBlock: eventTyprForGameBlock,
            shouldHideSidePanels: false,
            branchID: parseInt(event.sportId)
        };
    };
    Parser.prototype.openStats = function (statisticsEventId, e) {
        var statData = this.getStatisticsData(statisticsEventId);
        this.retriever.dataProvider.statisticsProvider.openStats(statData, e);
    };
    Parser.prototype.openLiveStream = function (eventId) {
        this.messageBus.sendLiveStreamMessage(eventId);
    };
    Parser.prototype.getStatisticsData = function (statisticsEventId) {
        return __assign({}, EmptyStatisticsData, { betRadarData: {
                clientId: this.clientId,
                eventId: statisticsEventId
            } });
    };
    /**
     * Store retrieved data helpers
     */
    Parser.prototype.isCurrentSportsDataLoaded = function () {
        return (!this.retriever.data.events.length || this.retriever.loadedData.containsSportIds(this.sports));
    };
    Parser.prototype.isCurrentDatesDataLoaded = function () {
        var date = this.dateRange && this.dateRange.from ? this.dateRange.from : new Date();
        return this.retriever.loadedData.containsSportIdsAndDate(this.sports, date);
    };
    Parser.prototype.isCurrentTagsDataLoaded = function (tag) {
        return this.retriever.loadedData.containsTag(tag);
    };
    Parser.prototype.clearData = function () {
        this.data = { events: observable([]), markets: observable([]), leagues: observable([]) };
    };
    Parser.prototype.updateData = function () {
        this.updateEvents();
        this.updateMarkets();
        this.updateLeagues();
    };
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Parser.prototype, "data", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], Parser.prototype, "sports", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Parser.prototype, "dateRange", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], Parser.prototype, "oddStyle", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], Parser.prototype, "timeZone", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], Parser.prototype, "isInFavoritesState", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], Parser.prototype, "isMiniEventCard", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Parser.prototype, "loader", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "activate", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "deactivate", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "sportsChange", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "leaguesChange", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "regionsChange", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "datesChange", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "liveStreamChange", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "favoritesChange", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "liveStreamingChange", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "fastMarketsChange", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "allEventsChange", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "activeEventIdChange", null);
    __decorate([
        Debounce,
        __metadata("design:type", Object)
    ], Parser.prototype, 249, void 0);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "changedToSide", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "betslipAddedItemsReceived", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "betslipRemovedItemsReceived", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "betslipClearedItemsReceived", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "betSlipStatusReceived", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "oddStyleChange", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "timeZoneChange", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "updateEvents", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "updateMarkets", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "updateSingleMarkets", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "mapEvents", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "mapMarkets", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "mapLeagues", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "updateLoader", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "updateLeagues", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "updateSingleEvent", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "manageFavorites", null);
    return Parser;
}());
export { Parser };
//# sourceMappingURL=parser.js.map